import React from "react";

export function PublishButtonIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      fill="none"
      viewBox="0 0 16 18"
      className="inline -mt-0.5"
    >
      <path
        fill="#FFF"
        d="M15.072 13.502a5.622 5.622 0 00-3.214-5.08v-3.33c0-.304-.106-.598-.303-.829L8.493.633a.642.642 0 00-.984 0l-3.062 3.63a1.285 1.285 0 00-.303.828v3.33A5.622 5.622 0 00.93 13.504h3.144c-.047.144-.07.3-.07.478a1.951 1.951 0 001.295 1.836A2.929 2.929 0 008.001 17.6c.585 0 1.151-.173 1.635-.498a2.916 2.916 0 001.065-1.286c.34-.12.64-.333.866-.613a1.96 1.96 0 00.43-1.221c0-.17-.022-.33-.062-.479h3.137v-.002zM13.03 11.2c.188.294.341.609.452.936h-1.704V9.941c.501.327.928.756 1.252 1.26zM5.51 8.422v-3.3l2.491-2.954 2.491 2.953v7.015H5.51V8.422zm-2.99 3.714A4.274 4.274 0 014.225 9.94v2.196H2.521zm7.814 2.335a.541.541 0 01-.344.068l-.392-.048-.056.39a1.564 1.564 0 01-1.54 1.336c-.77 0-1.433-.575-1.542-1.336l-.056-.392-.392.05a.565.565 0 01-.627-.56.53.53 0 01.294-.478h4.646a.53.53 0 01.294.478.57.57 0 01-.285.492zM7.037 6.753a.964.964 0 101.928 0 .964.964 0 00-1.928 0z"
      ></path>
    </svg>
  );
}